module.exports = __webpack_public_path__ + "img/img_82837_0_23.b4dafc44.png";